module.exports = __webpack_public_path__ + "static/media/text.bec4a986.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/text.gif
// module id = 427
// module chunks = 0